import React, { useEffect } from 'react'
import { ThemeProvider } from 'styled-components'
import { StoreProvider } from 'contexts'
import Router from 'router'
import theme from 'theme'
import { GlobalStyles } from 'theme/GlobalStyles'
import { updateMetaConfig } from 'hooks/useMetaConfig'

function App() {
    useEffect(() => {
        updateMetaConfig()
    }, [])

    return (
        <ThemeProvider theme={theme}>
            <StoreProvider>
                <GlobalStyles />
                <Router />
            </StoreProvider>
        </ThemeProvider>
    )
}

export default App
